import { useUser } from '@/hooks/use-user'
import { CABINET_HEALTH_TAG } from '@/components/dashboard/layout/workspaces/workspaces-context'

/** Whether the current user can see the cabinet health / service-status experience. */
export function useHealthAccess(): boolean {
	const { user } = useUser()
	return user?.tags?.includes(CABINET_HEALTH_TAG) ?? false
}
